if (document.body.classList.contains("contact")) {
    let elm = document.querySelector(".mw_wp_form")
    if (elm.querySelector(".error") || elm.classList.contains("mw_wp_form_confirm")) {
        const rect = elm.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = innerWidth * 0.1;
        const target = rect + offset - gap;
        window.scrollTo({
            top: target,
            behavior: 'smooth',
        })
    }
}